export default __webpack_public_path__ + "static/media/Crisis.34161ba4.png";